import { render } from "./HeaderComponents.vue?vue&type=template&id=dd86b304"
const script = {}

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__